var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [(_vm.role === 'General Affair')?_c('h5',[_vm._v("Surat Tugas")]):_c('h5',[_vm._v("Persetujuan FPP (Formulir Pengajuan Permintaan, Perbaikan & Penggantian)")])]},proxy:true}])},[_c('TableInternalMemo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }